import { Task } from '../models/task.model';
import { Recognition } from '../models/recognition.model';
import { Broadcast } from '../models/broadcast.model';
import { AllStatusesTypes } from 'interfaces';

export interface FileType extends File {
  id?: string;
  url?: string;
}

export interface ServerAttachment {
  id: string;
  name: string;
  type: string;
  size: number;
  url?: string;
  objectKey?: string;
}

export type Attachment = File | ServerAttachment;

export const isServerAttachment = (
  attachment: Attachment,
): attachment is ServerAttachment => !(attachment instanceof File);

export const isLocalFile = (attachment: Attachment): attachment is File =>
  attachment instanceof File;

export type AttachmentEntityType = 'recognitions' | 'broadcasts' | 'tasks';

export interface GetAllItemsParams {
  status?: AllStatusesTypes;
  isOwner?: boolean;
  /** When true, backend returns only items favourited by the current admin */
  favourites?: boolean;
}

export type ItemOneOf = Task | Recognition | Broadcast;
